var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1727 357L1727 385",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1727.5,
    cy: 352.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1722.99 352.19C1722.99 348.283 1726.29 345.117 1730.36 345.117C1730.94 345.117 1731.51 345.184 1732.06 345.308C1730.74 344.48 1729.19 344 1727.52 344C1722.81 344 1719 347.806 1719 352.5C1719 357.194 1722.81 361 1727.52 361C1729.81 361 1731.89 360.093 1733.43 358.62C1732.49 359.032 1731.45 359.263 1730.36 359.263C1726.29 359.263 1722.99 356.096 1722.99 352.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1736.4 351.6L1736.37 349.146L1734.54 350.719L1732.3 350.056L1733.11 352.337L1731.77 354.381L1734.1 354.218L1735.5 356.144L1736.13 353.763L1738.34 352.909L1736.4 351.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch4);
export default __webpack_public_path__ + "static/media/church_4.a6c708701504f26868bd3b2211d55868.svg";
export { ForwardRef as ReactComponent };